import Vue from 'vue'
import './public-path'
import App from './App.vue' // 根组件
import VueRouter from 'vue-router'
import routes from './router'
import store from './store'
import './utils/rem'
import './utils/antd'
import './css/index.scss'
import PriceInput from '@component/priceInput'
import CommonQuerySelect from '@component/commonQuerySelect'
import CommonSelect from '@component/commonSelect'
import CommonTable from '@component/commonTable'
import OperateBtn from '@component/operateBtn'
import VoucherBtn from '@component/voucherBtn'
import FindRelatedDocBtn from '@component/findRelatedDocBtn'
import ModalBox from '@component/modalBox'
import SelectDocumentType from '@component/selectDocumentType'
import SelectSettlementMethod from '@component/selectSettlementMethod'
import actions from './qiankun/actions2'
import i18n from './utils/lang'
import i18nPlugin from './utils/i18n'
// 注册全局过滤器
import * as filters from './common/filters' // global filters

Vue.use(i18nPlugin)

Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
  Vue.prototype['$' + key] = filters[key]
})

Vue.component('PriceInput', PriceInput)
Vue.component('CommonSelect', CommonSelect)
Vue.component('OperateBtn', OperateBtn)
Vue.component('VoucherBtn', VoucherBtn)
Vue.component('FindRelatedDocBtn', FindRelatedDocBtn)
Vue.component('CommonQuerySelect', CommonQuerySelect)
Vue.component('CommonTable', CommonTable)
Vue.component('ModalBox', ModalBox)
Vue.component('SelectDocumentType', SelectDocumentType)
Vue.component('SelectSettlementMethod', SelectSettlementMethod)

Vue.prototype.$isEmpty = (val) => {
  return val === null || val === undefined || val === ''
}
const env = 'dev'

Vue.config.devtools = env === 'dev' ? true : false
Vue.config.silent = env === 'dev' ? false : true

let router = null
let instance = null
function render(props = {}) {
  const { container } = props
  if (props) {
    // 注入 actions 实例
    actions.setActions(props)
  }
  router = new VueRouter({
    base: '/',
    mode: 'history',
    routes,
  })

  // router.beforeEach((to, from, next) => {
  //   if (to.name === 'login') {
  //     if (!getCookie('d_session_id')) {
  //       next()
  //     } else {
  //       next({ name: 'payableList' })
  //     }
  //   } else if (!getCookie('d_session_id')) {
  //     localStorage.setItem('pageCacheFullPath', to.fullPath)
  //     next({ name: 'login' })
  //     return
  //   }
  //   next()
  // })

  Vue.use(VueRouter)
  instance = new Vue({
    i18n,
    router,
    store,
    render: (h) => h(App),
  }).$mount(container ? container.querySelector('#app') : '#app')
}

// 独立运行时
if (!window.__POWERED_BY_QIANKUN__) {
  render()
}

export function getRouter() {
  return router
}

export async function bootstrap() {
  console.log('[vue2] fms app bootstraped')
}

export async function mount(props) {
  render(props)
}

export async function unmount() {
  instance.$destroy()
  instance.$el.innerHTML = ''
  instance = null
  router = null
}
